import {observable, action} from "mobx";
import { ServiceBase } from "../ServiceBase";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import { IOmgProxyService } from "./omg-proxy.service.interface";

export class OmgProxyService extends ServiceBase implements IOmgProxyService {
    @observable
    numberOfAwaitingMessages = 0;

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        this.setNumberOfAwaitingMessages(this.services.sdk.getNumberOfAwaitingMessages());
        this.subscribe();
    }

    private subscribe() {
        this.services.sdk.events.onOmgAwaitingMessagesUpdated((updatedNumberOfMessages) => {
            this.setNumberOfAwaitingMessages(updatedNumberOfMessages);
        });
    }

    @action
    private setNumberOfAwaitingMessages(n: number) {
        this.numberOfAwaitingMessages = n;
    }

    public openOmgAwaitingMessages() {
        this.services.sdk.openOmgAwaitingMessages();
    }
}
